<template>
    <div class="security-wrapper">
        <header-security v-if="isJACareerEntrepreApp"/>
        <div class="security">
            <b-container :class="[isJACareerEntrepreApp ? 'security-container' : '']">
                <b-row v-if="isIntuitApp" class="d4d-decoration">
                </b-row>
                <b-row v-if="isJAApp" class="ja-decoration">
                </b-row>
                <b-form @submit.prevent="register()" v-if="!isJACareerEntrepreApp">
                    <b-row class="d4d-login">

                        <b-col cols="12" class="mt-1 title">Create an Account</b-col>

                        <b-col cols="12" class="mt-3">
                            <label for="email">Email address</label>
                            <input id="email" type="text" v-model="form.email" value="">
                            <span v-if="emailError" class="form-error">This field is required</span>
                            <ul class="error-content ">
                                <li class="error-text" v-for="error in emailErrors" :key="error">{{ error }}</li>
                            </ul>
                        </b-col>
                        <b-col cols="12 mt-4">
                            <label for="password">Password</label>
                            <input id="password" type="password" v-model="form.password" value="">
                            <span v-if="passwordError" class="form-error">This field is required</span>
                            <ul class="error-content">
                                <li class="error-text" v-for="error in passwordErrors" :key="error">{{ error }}</li>
                            </ul>
                        </b-col>
                        <b-col cols="12 mt-4">
                            <label for="confirm-password">Confirm Password</label>
                            <input id="confirm-password" type="password" v-model="form.confirmPassword" value="">
                            <span v-if="confirmPasswordError" class="form-error">{{ confirmPasswordError }}</span>
                        </b-col>
                        <b-col cols="12 mt-4">
                            <label for="confirm-password">Date of Birth</label>
                            <div class="field-select">
                                <div class="field-select-item">
                                    <v-select v-model="form.month" :clearable="false" placeholder="Month" :searchable="false"
                                            :options="months"/>
                                </div>
                                <div class="field-select-item">
                                    <v-select v-model="form.day" :clearable="false" placeholder="Days" :searchable="false"
                                            :options="days"/>
                                </div>
                                <div class="field-select-item">
                                    <v-select v-model="form.year" :clearable="false" placeholder="Year" :searchable="false"
                                            :options="years"/>
                                </div>
                            </div>
                            <span v-if="birthdayError" class="form-error">This field is required</span>
                            <span class="error-text" v-for="error in DateOfBirthErrors" :key="error"> {{ error  }} </span>
                            <b-link class="birthday-text" @click="$bvModal.show('modal-children-privacy-protection')">Why do I need to provide my
                                birthday?
                            </b-link>
                        </b-col>
                        <b-col cols="12" class="mt-5">
                            <b-button block variant="primary" type="submit">Create Account</b-button>
                        </b-col>
                        <legal-warning button="Create Account" :show-date="false"/>
                        <b-col cols="12" class="mt-3">
                            <div class="separator"></div>
                        </b-col>
                        <b-col cols="12" class="mt-1 mb-4 text-center">
                            <router-link :to="{ name: 'Login' }">
                                <span class="black-text"> Already have a D4D account?  </span>
                                <span class="green-text">Sign In</span>
                            </router-link>
                        </b-col>
                    </b-row>
                </b-form>
                <b-form @submit.prevent="register()" v-if="isJACareerEntrepreApp">
                    <b-row class="security-content">

                        <b-col cols="12" class="mt-1 security-title">Create an Account</b-col>

                        <b-col cols="12" class="mt-3 security-section">
                            <label for="email" class="security-section__subtitle">Email address</label>
                            <input class="security-section__input" id="email" type="text" v-model="form.email" value="">
                            <span v-if="emailError" class="text-error">This field is required</span>
                            <ul class="security-section__list">
                                <li class="text-error" v-for="error in emailErrors" :key="error">{{ error }}</li>
                            </ul>
                        </b-col>
                        <b-col cols="12 mt-2" class="security-section">
                            <label for="password" class="security-section__subtitle">Password</label>
                            <input class="security-section__input" id="password" type="password" v-model="form.password" value="">
                            <span v-if="passwordError" class="text-error">This field is required</span>
                            <ul class="security-section__list">
                                <li class="text-error" v-for="error in passwordErrors" :key="error">{{ error }}</li>
                            </ul>
                        </b-col>
                        <b-col cols="12 mt-2" class="security-section">
                            <label for="confirm-password" class="security-section__subtitle">Confirm Password</label>
                            <input class="security-section__input" id="confirm-password" type="password" v-model="form.confirmPassword" value="">
                            <span v-if="confirmPasswordError" class="text-error">{{ confirmPasswordError }}</span>
                        </b-col>
                        <b-col cols="12 mt-3" class="security-section">
                            <label for="confirm-password" class="security-section__subtitle">Date of Birth</label>
                            <div :class="{'isCareerEntrep': isJACareerEntrepreApp}" class="field-select">
                                <div class="field-select-item">
                                    <v-select v-model="form.month" :clearable="false" placeholder="Month" :searchable="false"
                                            :options="months"/>
                                </div>
                                <div class="field-select-item">
                                    <v-select v-model="form.day" :clearable="false" placeholder="Days" :searchable="false"
                                            :options="days"/>
                                </div>
                                <div class="field-select-item">
                                    <v-select v-model="form.year" :clearable="false" placeholder="Year" :searchable="false"
                                            :options="years"/>
                                </div>
                            </div>
                            <span v-if="birthdayError" class="text-error">This field is required</span>
                            <span class="text-error" v-for="error in DateOfBirthErrors" :key="error"> {{ error  }} </span>
                            <b-link class="text__birthday--green" @click="$bvModal.show('modal-children-privacy-protection')">Why do I need to provide my
                                birthday?
                            </b-link>
                        </b-col>
                        <b-col cols="12" class="mt-3 security-button">
                            <b-button block variant="primary" type="submit" class="security-button__primary">Create Account</b-button>
                        </b-col>
                        <b-col cols="12" class="mt-1 mb-3 text-center security-description">
                            <router-link :to="{ name: 'Login' }">
                                <span class="security-description__text text--black">Already have an account?  </span>
                                <span class="security-description__text text--green">Sign In</span>
                            </router-link>
                        </b-col>
                        <b-col cols="12" class="mt-4 security-description">
                            <p class="security-description__text text--black">By logging in, you agree to our 
                                <a :href="Constants.TERMS_CONDITIONS_URL" target="_blank"><span class="security-description__text text--green">Terms</span></a>
                                and have read and acknowledge our 
                                <a :href="Constants.PRIVACY_POLICY_URL" target="_blank"><span class="security-description__text text--green">US Privacy Statement</span></a>.
                                <br/><span class="security-description__text text--bold">Updated on January 1, 2020</span></p>
                        </b-col>
                        <b-col class="security-footer">
                            <span class="security-footer__text">©Junior Achievement USA</span>
                        </b-col>
                    </b-row>
                </b-form>
                <legal-message v-if="!isJACareerEntrepreApp"/>
                <children-privacy-protection/>
            </b-container>
        </div>
    </div>
</template>

<script>
    import {UserService} from '../Services'
    import {Accounts, Spinner, Constants} from '@/core/Utils'
    import LegalWarning from "../Components/LegalWarning"
    import LegalMessage from "../Components/LegalMessage"
    import ChildrenPrivacyProtection from "../Components/ChildrenPrivacyProtection"
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';
    import validateForms from '../../../core/Mixins/validate-forms'
    import HeaderSecurity from "../Components/HeaderSecurity"

    export default {
        name: 'Register',
        components: {
            LegalWarning,
            LegalMessage,
            vSelect,
            ChildrenPrivacyProtection,
            HeaderSecurity
        },
        mixins: [validateForms],
        data() {
            return {
                days: Accounts.getDays(),
                months: Accounts.getMonths(),
                years: Accounts.getYears(),
                form: {email: "", password: "", confirmPassword: "", day: "", month: "", year: "", dateOfBirth:""},
                emailError: false,
                passwordError: false,
                confirmPasswordError: "",
                birthdayError: "",
                emailErrors: [],
                passwordErrors: [],
                serviceError: false ,
                DateOfBirthErrors: [],
                Constants: Constants
            }
        },
        methods: {
            register() {
                const {email, password, confirmPassword, day, month, year} = this.form

                this.emailErrors = []
                this.passwordErrors = []
                this.DateOfBirthErrors = []
                this.serviceError = false
                this.emailError = email === ""
                this.passwordError = password === ""
                this.birthdayError = !month || !day || !year
                if (confirmPassword === "") this.confirmPasswordError = "This field is required"
                if (password !== confirmPassword) this.confirmPasswordError = "Must coincide with password"
                if (confirmPassword !== "" && password === confirmPassword) this.confirmPasswordError = ""

                if (email && password && confirmPassword && password === confirmPassword && month && day && year && this.isValidform()) {
                    Spinner.start()
                    this.form.dateOfBirth = Accounts.getDateFormat(`${year}-${month.code}-${day}`)

                    UserService.registerUser(this.form).then(response => {
                        Spinner.stop()
                        if(response.parentConsentRequired){
                               this.$router.push({ name: 'ParentConsentRequired', params: { userId: response.user.id } })
                        }else{
                            this.$router.push({name: 'VerifyEmail'})
                        }
                    }).catch(err => {
                        Spinner.stop()
                        if (err) {
                            if (err.message) {
                                this.serviceError = err.message
                            }
                            if (err.errors) {
                                if (err.errors['Password']) {
                                    err.errors['Password'].forEach(error => this.passwordErrors.push(error))
                                }
                                if (err.errors['Email']) {
                                    err.errors['Email'].forEach(error => this.emailErrors.push(error))
                                }
                                if (err.errors['DateOfBirth']) {
                                    err.errors['DateOfBirth'].forEach(error => this.DateOfBirthErrors.push(error))
                                }
                            }
                        }
                    })
                }
            }
        }
    }

</script>
<style scoped lang="stylus">
    @import "~@/core/Styles/variables.styl"
    @import "../Styles/security_styles.styl"

    .field-select + .form-error
        display block

    .field-select .birthday-text
        font font-sourcesans-regular
        font-size 14px
        color color-5

    .field-select
        display flex
        flex-direction row

        &-item
            flex 1
            padding-left 0.5em

            &:first-child
                padding-left 0
                flex 2

    .text__birthday--green
        color color-green-light
        font font-sourcesans-regular
        font-size 16px

</style>
